export default "__VITE_ASSET__k9PXtzPr__"